module.exports = __webpack_public_path__ + "img/vampship.0b2c1bec.webp";